import { render, staticRenderFns } from "./ReplaceInvoiceVAT.vue?vue&type=template&id=563e11fc"
import script from "./ReplaceInvoiceVAT.vue?vue&type=script&lang=js"
export * from "./ReplaceInvoiceVAT.vue?vue&type=script&lang=js"
import style0 from "./ReplaceInvoiceVAT.vue?vue&type=style&index=0&id=563e11fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports